export enum TipoAutenticacaoCardapio {
    "SIMPLES" = "SIMPLES",
    "VERIFICADA" = "VERIFICADA"
}

export enum TipoAutenticacaoCardapioTitulo {
    "SIMPLES" = "Simples (Recomendado)",
    "VERIFICADA" = "Verificada"
}

export enum TipoAutenticacaoCardapioDescricao {
    "SIMPLES" = "Autenticação simplificada que exige apenas nome e telefone do cliente.",
    "VERIFICADA" = "Autenticação completa que exige verificação de e-mail ou telefone do cliente."
}
